/**
 * Parses a time string (e.g., "9am", "14:30") into hours and minutes.
 */
export const parseTime = (timeStr: string | null) => {
  if (!timeStr) {
    return null;
  }
  const originalTimeStr = timeStr;
  timeStr = timeStr.toLowerCase();
  const isPm = timeStr.includes('pm');
  const isAm = timeStr.includes('am');
  const time = timeStr.replace(/am|pm/i, '');
  const parts = time.split(':');

  let hours = parseInt(parts[0], 10);
  const minutes = parts.length > 1 ? parseInt(parts[1], 10) : 0;

  if (isNaN(hours) || isNaN(minutes)) {
    return null;
  }
  if (isPm && hours < 12) {
    hours += 12;
  }
  // Midnight case
  if (isAm && hours === 12) {
    hours = 0;
  }

  if (hours < 0 || hours > 24) {
    return null;
  }
  if (minutes < 0 || minutes > 59) {
    return null;
  }
  if (hours === 24 && minutes > 0) {
    return null;
  }
  // 24:00 is the start of the next day
  if (hours === 24) {
    hours = 0;
  }

  return {
    hours,
    minutes,
    original: originalTimeStr,
    inMilliseconds: hours * 60 * 60 * 1000 + minutes * 60 * 1000,
  };
};
